export default {
    message: {
        impersonation: "Sie bestellen im Namen von «{name}»"
    }
}